


































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Subnet from '@/js/Subnet'
import Indexed from '@/components/Blockchain/Indexed.vue'
import { DEFAULT_NETWORK_ID } from '@/store/modules/network/network'

@Component({
    components: {
        Indexed,
    },
})
export default class ControlKeyTable extends Vue {
    @Prop() subnet!: Subnet
    @Prop() title?: string

    get imgColor(): string {
        return DEFAULT_NETWORK_ID === 1 ? 'testnet' : 'testnet'
    }
}
